import axios from 'axios';

const API_BASE = '/api/transport/portal';

export const transportPortalService = {
  getJob: async (token) => {
    const response = await axios.get(`${API_BASE}/${encodeURIComponent(token)}`);
    return response.data;
  },
  uploadFile: async (token, { file, kind }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    const response = await axios.post(
      `${API_BASE}/${encodeURIComponent(token)}/files`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },
  downloadUrl: (token, fileId) =>
    `${API_BASE}/${encodeURIComponent(token)}/files/${fileId}/download`,
  markPickedUp: async (token) => {
    const response = await axios.post(`${API_BASE}/${encodeURIComponent(token)}/mark-picked-up`);
    return response.data;
  },
  markDelivered: async (token) => {
    const response = await axios.post(`${API_BASE}/${encodeURIComponent(token)}/mark-delivered`);
    return response.data;
  },
  complete: async (token) => {
    const response = await axios.post(`${API_BASE}/${encodeURIComponent(token)}/complete`);
    return response.data;
  },
};
